import Accessorials from "../../views/accessorials/Index.vue";

const AccessorialsRoute = [
  {
    path: "/accessorials",
    name: "Accessorials",
    component: Accessorials,
  },
];

export default AccessorialsRoute;
